module.exports = __webpack_public_path__ + "static/img/accountFlow.2eb3c1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/accountFlow.png
// module id = 124
// module chunks = 1